import React from 'react';
import { RequestStatus, ScreenType } from "Constants";
import ReservationService from 'Services/reservation.service';
import "./styles.sass";
// @ts-ignore
import { LocalizationContext } from "react-localize";
import { btnContent } from 'Generic/Buttons/ViewControllerBtns/VCButton/VCButton';
import { Transaction, TransactionHistoryType } from 'Interfaces/Transactions';
import { MvSortTable } from 'Generic/MvSortTable';
import moment from 'moment';
import { activeTransactionsSortField, Transactions } from './ByTransaction/Transactions';
import ContractToolTip from 'Interfaces/ContractToolTipInterface';
import { OwnerContract, OwnerShipDetails } from 'Interfaces/OwnerInterface';
import { RequestError } from 'Interfaces/RequestError';
import MvContractToolTip from 'Generic/ToolTip/MvContractToolTip';
import { Position } from 'Generic/ToolTip/ToolTip';
import { MvConfirmationModal } from 'Generic/MvConfirmationModal/MvConfirmationModal';
import { TransactionFilter, TransactionFilters } from 'Generic/MvTransactionFilter/types';
import LocalizationService from "Services/localization.service";

type Props = {
    token: string;
    lang: string;
    resId: number;
    setScreenType(screenType: ScreenType): void;
    apiTimeout: string;
};

type State = {
    activeBtn: TransactionHistoryType;
    showErrorModal: boolean;
    errorMessage: string;
    [TransactionHistoryType.BY_USAGE]: {
        requestStatus: RequestStatus;
        transactions: Transaction[];
        contratToolTips: ContractToolTip[];
    };
    [TransactionHistoryType.BY_TRANSACTION]: {
        requestStatus: RequestStatus;
        transactions: Transaction[];
        filters: TransactionFilters;
        contratToolTips: ContractToolTip[];
        activeSortField: activeTransactionsSortField|null;
    };
} 

const InitState: State = {
    activeBtn: TransactionHistoryType.BY_TRANSACTION,
    showErrorModal: false,
    errorMessage: '',
    [TransactionHistoryType.BY_USAGE]: {
        requestStatus: RequestStatus.LOADED,
        transactions: [],
        contratToolTips: [],
    },
    [TransactionHistoryType.BY_TRANSACTION]: {
        requestStatus: RequestStatus.LOADING,
        transactions: [],
        filters: {
            [TransactionFilter.transactionYears]: [],
            [TransactionFilter.transactionTypes]: [],
            [TransactionFilter.contracts]: [],
            [TransactionFilter.usageYears]: [],
            [TransactionFilter.usageTypes]: [],
            [TransactionFilter.userName]: [],
        },
        contratToolTips: [],
        activeSortField: null,
    },
}

class TransactionHistory extends React.Component<Props, State> {
    reservationService: ReservationService;
    localizationService: LocalizationService;
    _isMounted: boolean;

    constructor(props: Readonly<Props>) {
        super(props);

        this.state = Object.assign({}, InitState);
        this.reservationService = new ReservationService();
        this.localizationService = new LocalizationService();
        this.setActive = this.setActive.bind(this);
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        const activeBtn = this.state.activeBtn;

        if (this.state[activeBtn].transactions.length === 0) {
            switch(activeBtn) {
                case TransactionHistoryType.BY_TRANSACTION :
                    this.fetchTransactions();
                    break;
                case TransactionHistoryType.BY_USAGE :
                    this.fetchUsageTransactions();
                    break;
            }
        }
    }

    componentWillUnmount(): void {
        this._isMounted = false;
    }

    setActive(key: TransactionHistoryType) {
        this.setState({activeBtn: key});
    }

    fetchTransactions() {
        const key = TransactionHistoryType.BY_TRANSACTION;
        if (this.state[key].transactions.length === 0) {
            const newLoadingState = {...this.state}; 
            newLoadingState[key].requestStatus = RequestStatus.LOADING;
            
            this.setState(newLoadingState, () => {
                this.reservationService.getTransactions().then(transResponse => {
                    
                    transResponse.transactions.map(trans => {
                        trans.friendlyUsageType = this.getFriendlyUsageType(trans.usageType)
                        trans.friendlyTransactionType = this.getFriendlyTransactionType(trans.type)
                    })

                    const newState = {...this.state};
                    newState[key].transactions = transResponse.transactions;
                    newState[key].filters = transResponse.filters;
                    newState[key].requestStatus = RequestStatus.LOADED;
                    this.setState(newState);
                    this.fetchContactTooltips(key);
                    
                }).catch(error => {
                    const newErroredState = {...this.state}; 
                    newErroredState[key].requestStatus = RequestStatus.ERRORED;

                    if (error.code !== 401) {
                        const newErroredState = {...this.state}; 
                        newErroredState[key].requestStatus = RequestStatus.ERRORED;
                        newErroredState.showErrorModal = true;
                        newErroredState.errorMessage = error.message;

                        this.setState(newErroredState);
                    } else {
                        this.setState(newErroredState);
                    }
                });
            });
        }
    }

    getFriendlyTransactionType = (transactionType: string) => {
        const friendlyName = this.localizationService.getTransactionTypeNameFromJahia(transactionType);
        return friendlyName.value || friendlyName.key;
    };

    getFriendlyUsageType = (usageType: string) => {
        return this.localizationService.getUsageTypeNameFromJahia(usageType).value;
    };
    
    fetchUsageTransactions() {
        const key = TransactionHistoryType.BY_USAGE;
        //TODO: fetch by Usage
    }

    /**
     * Gets and stores the contract tooltip data for all contracts
     */
    fetchContactTooltips(activeBtn: TransactionHistoryType) {
        if (!this.state[activeBtn].transactions) return [];

        return new Promise((resolve, reject) => {
            // get a unique list of contract Ids
            const contractList: any = new Set(this.state[activeBtn].transactions.map(transactions => transactions.contractId));

            // get the contracts' data
            this.reservationService.getOwnerContracts(contractList)
                .then((ownerContracts: OwnerContract[]) => {

                // build the ContractToolTip[]
                let contractToolTips: ContractToolTip[] = [];
                ownerContracts.map(contract => {
                    // convert OwnerContract to ContractToolTip
                    let tempContractToolTip = this.convertOCtoCTT(contract);
                    // get the tooltip jsx
                    tempContractToolTip.toolTip = this.getContractToolTipJSX(tempContractToolTip);
                    contractToolTips.push(tempContractToolTip);
                });

                if (this._isMounted) {
                    const newState = {...this.state};
                    newState[activeBtn].contratToolTips = contractToolTips;
                    this.setState(newState);
                }
                resolve();
            })
            .catch((error: RequestError) => {
                reject(error);
            });
        });
    }

    /**
     * Converts the contract info into a ContracToolTip
     */
    getContractToolTipJSX(contractToolTip: ContractToolTip): any {
        const contractId = contractToolTip.contractId;
        const key = contractId + contractToolTip.startDate + contractToolTip.endDate + (contractToolTip.points ? contractToolTip.points.toString() : '');
        const contractIdStyle = <p key={key} className="contract-id-link mv-print-link" aria-label={contractId}>{contractId}</p>

        return <MvContractToolTip useRefToPosition={true} contract={contractToolTip} position={Position.CENTER}>
                {contractIdStyle}
            </MvContractToolTip>;
    }

    convertOCtoCTT(oc: OwnerContract): ContractToolTip {
        // the AYP table is still returning mock data? that will be returning real
        //  data this sprint by Rama - done by tomorrow perhaps
        // getting CORS error
        return {
            id: oc.id, 
            contractId: oc.contractNumber, 
            contractType: oc.contractType,
            // hard code to points for now
            // the service is not providing this field 
            // it is also not returning any weeks data
            typeName: "points", 
            startDate: oc.contractStartDate,
            endDate: oc.contractEndDate,
            // this field is missing from the service
            // it is being looked into
            // so for now, just show the start date's year
            usageYear: oc.contractStartDate,
            points: oc.contractPoints,
            ownershipDetails: oc.ownershipDetails ? oc.ownershipDetails : {} as OwnerShipDetails //CE2RT1C-899 - 8. add ownersheip details to contract tool tip
        };
    }

    handleTransactionsSort = (sortedTransactions: Transaction[], activeSortField: activeTransactionsSortField) => {
        const newState = {...this.state};
        const stateKey = newState[TransactionHistoryType.BY_TRANSACTION];
        stateKey.transactions = sortedTransactions;
        stateKey.activeSortField = activeSortField;
        this.setState(newState);
    }

    toggleErrorModal = () =>  {
        this.setState({showErrorModal: !this.state.showErrorModal});
    }



    render() {
        const { localize } = this.context;
        
        const btnContents: btnContent[] = [
            {
                copy: localize("static.content.vcbutton-byusage"),
                route:"",
                key: TransactionHistoryType.BY_USAGE
            },
            {
                copy: localize("static.content.vcbutton-bytransaction"),
                route:"",
                key: TransactionHistoryType.BY_TRANSACTION
            }
        ]

        const transState = this.state[TransactionHistoryType.BY_TRANSACTION];
        
        return (
            <div className='transaction-history-page'>
                <MvConfirmationModal
                    header = {localize("static.content.transactions-error-header")}
                    description = {this.state.errorMessage}
                    message = ""
                    abortLabel = ""
                    confirmLabel = {localize("static.content.transactions-confirm-error")}
                    openModal={this.state.showErrorModal}
                    toggleModal={this.toggleErrorModal}
                    confirm={this.toggleErrorModal}
                    abort={() => {}}
                />
                <h2 className="table-title">{localize("static.content.page-header")}</h2>
                {/* TODO: uncomment below when implementing BY_USAGE */}
                {/* <VCBContainer btnContents={btnContents} setActive={this.setActive} activeBtn={this.state.activeBtn}/> */}
                <div className="transactions-container">
                    {(this.state.activeBtn === TransactionHistoryType.BY_USAGE) &&
                        <MvSortTable
                            rowKey="resId"
                            headers={[]}
                            rows={[]}
                            rowsExpandable={true}
                            dataStatus={this.state[TransactionHistoryType.BY_USAGE].requestStatus}
                            headerSection={
                            <div className="transactions-header">
                                <div className="table-info">
                                    <h4>
                                        {localize("static.content.table-header-byusage")}
                                    </h4>
                                    <span className="transactions-subheader">
                                        {localize("static.content.table-subheader-byusage")}
                                    </span>
                                    {/* {this.state[TransactionHistoryType.BY_USAGE].requestStatus === RequestStatus.LOADED && this.state[TransactionHistoryType.BY_USAGE].transactions.length === 0 &&
                                        <div className="transactions-none">{localize("You currently do not have any transaction history")}</div>
                                    } */}
                                </div>
                            </div>
                            }
                            minWidth={1}
                            columnStyles={[]}
                            apiTimeout = {this.props.apiTimeout}
                        />
                     }
                    {(this.state.activeBtn === TransactionHistoryType.BY_TRANSACTION) &&
                        <Transactions
                            transactions={transState.transactions}
                            filters={transState.filters}
                            contractToolTips={transState.contratToolTips}
                            requestStatus={transState.requestStatus}
                            activeSortField={transState.activeSortField}
                            onTransactionsSort={this.handleTransactionsSort}
                            apiTimeout = {this.props.apiTimeout}
                        />
                     }
                </div>
            </div>
        );
    }

};

TransactionHistory.contextType = LocalizationContext;
export {
    TransactionHistory,
};